import React, { useState, useEffect } from "react";
import { Form, Icon, Table } from "semantic-ui-react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { differenceWith } from "lodash";

import TableButton from "components/TableButton";

const NoRevenueOpportunityStatuses = () => (
  <Table basic compact>
    <Table.Body>
      <Table.Row>
        <Table.Cell textAlign="center">
          <em>No Revenue Opportunity Statuses included in this preset</em>
        </Table.Cell>
      </Table.Row>
    </Table.Body>
  </Table>
);

const RevenueOpportunitySelector = ({
  revenueOpportunityStatuses,
  setRevenueOpportunityStatuses,
  allRevenueOpportunityStatuses,
  handleDragEnd,
}) => {
  const [options, setOptions] = useState([]);
  const [selection, setSelection] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const newOptions = differenceWith(
      allRevenueOpportunityStatuses,
      revenueOpportunityStatuses,
      (a, b) => a.id === b.id
    ).map(({ name }) => name);
    setOptions(newOptions);
  }, [allRevenueOpportunityStatuses, revenueOpportunityStatuses]);

  const handleSelect = (_, { value }) => {
    setSearchQuery(value);
    setSelection(value);
  };

  const handleSearchChange = (_, { searchQuery }) => {
    setSearchQuery(searchQuery);
  };

  const handleBlur = () => {
    if (searchQuery) {
      setSelection(searchQuery);
    }
  };

  const filterByName = name => {
    return (item = {}) =>
      item.name && name && item.name.toLowerCase() === name.toLowerCase();
  };

  const handleAdd = () => {
    if (!selection) {
      return;
    }
    const byName = filterByName(selection);
    const exists = revenueOpportunityStatuses.some(byName);
    if (!exists) {
      const { id, name } = allRevenueOpportunityStatuses.find(byName) || {};
      const newRevenueOpportunityStatuses = [
        ...revenueOpportunityStatuses,
        { id, name: name || selection },
      ];
      setRevenueOpportunityStatuses(newRevenueOpportunityStatuses);
    }
    setSearchQuery("");
    setSelection(null);
  };

  const handleDelete = name => {
    const index = revenueOpportunityStatuses.findIndex(
      item => item.name === name
    );
    if (index !== -1) {
      const newRevenueOpportunityStatuses = [
        ...revenueOpportunityStatuses.slice(0, index),
        ...revenueOpportunityStatuses.slice(index + 1),
      ];
      setRevenueOpportunityStatuses(newRevenueOpportunityStatuses);
    }
  };

  return (
    <>
      <Form.Group>
        <Form.Select
          label="Revenue Opportunity Statuses"
          inline
          required
          search
          noResultsMessage={null}
          options={[...options].map(name => ({
            key: name,
            text: name,
            value: name,
          }))}
          value={selection}
          searchQuery={searchQuery}
          onChange={handleSelect}
          onSearchChange={handleSearchChange}
          onBlur={handleBlur}
          selectOnBlur={false}
        />
        <Form.Button
          icon="plus"
          content="Add"
          size="tiny"
          basic
          onClick={handleAdd}
        />
      </Form.Group>
      {revenueOpportunityStatuses.length === 0 ? (
        <NoRevenueOpportunityStatuses />
      ) : (
        <DragDropContext
          onDragEnd={handleDragEnd}
          getContainer={() => document.body}
        >
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                <Table basic compact definition>
                  <Table.Body>
                    {revenueOpportunityStatuses.map(({ name }, index) => (
                      <Draggable key={name} draggableId={name} index={index}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                              top: snapshot.isDragging ? "50" : "initial",
                              left: snapshot.isDragging ? "0" : "initial",
                            }}
                          >
                            <Table.Row
                              key={name}
                              style={{ display: "inline-table", width: "100%" }}
                            >
                              <Table.Cell
                                style={{ width: "5px", background: "white" }}
                              >
                                <Icon name="bars" />
                              </Table.Cell>
                              <Table.Cell
                                style={{
                                  background: "rgb(0,0,0,0.3)",
                                  color: "black",
                                }}
                              >
                                {name}
                              </Table.Cell>
                              <Table.Cell collapsing>
                                <TableButton
                                  delete
                                  onClick={() => handleDelete(name)}
                                />
                              </Table.Cell>
                            </Table.Row>
                          </div>
                        )}
                      </Draggable>
                    ))}
                  </Table.Body>
                </Table>
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </>
  );
};

export default RevenueOpportunitySelector;
